module.exports = __webpack_public_path__ + "img/goods1.0d32db8a.jpg";